import React from "react";
import { Link } from "react-router-dom";
import { routes } from "../../utils/utils.routes";

type ProfileCardProps = {
  profile: StaffMember;
  showDescription?: boolean;
  variant?: "team" | "sidebar";
};

export const ProfileCard: React.FC<ProfileCardProps> = ({
  profile: { name, role, slug, uuid, description, image },
  showDescription = false,
  variant = "team",
}) => {
  const profileHref = slug ? `${routes.PROFILE}/${slug}` : undefined;

  const media = image ? (
    <img src={image} alt="" className="profile-card__img" loading="lazy" />
  ) : (
    <div className="profile-card__placeholder" aria-hidden>
      {name.charAt(0)}
    </div>
  );

  const body = (
    <>
      <div className="profile-card__media">{media}</div>
      <div className="profile-card__body text-center">
        <h3 className="profile-card__name">{name}</h3>
        <p className="profile-card__role">{role}</p>
        {showDescription && description && (
          <p className="profile-card__bio">{description}</p>
        )}
        {profileHref && (
          <span className="profile-card__cta">Voir le profil</span>
        )}
      </div>
    </>
  );

  return (
    <article
      className={`profile-card profile-card--${variant}${showDescription ? " profile-card--with-bio" : ""}`}
      key={uuid}
    >
      {profileHref ? (
        <Link to={profileHref} className="profile-card__link">
          {body}
        </Link>
      ) : (
        <div className="profile-card__link profile-card__link--static">{body}</div>
      )}
    </article>
  );
};
